import React from 'react';

const Footer = () => {
    return (
        <div className='p-4 text-center text-gray-600'>
            <small>@copyright 2022</small>
        </div>
    );
};

export default Footer;